import React from 'react';
import Package from './Package';
import NewId from '../../utils/NewId';

export default class PackageList extends React.Component {
    render() {
         let packages = this.props.packages.splice(0) || [];
         
         let filterPaidPackages = [];
         
        for(var i=0; i < packages.length; i++)
            {
                if(packages[i].price === '0.00')
                {
                  filterPaidPackages.push(packages[i]);   
                }
            }
        packages = filterPaidPackages;
        packages = packages.map( ( pckg ) => {
            //TODO remove this
            let completedMeditationsCount = 0;
            if (pckg.meditations) {
                completedMeditationsCount = pckg.meditations.filter(m => m.completed).length;
            }

            return Object.assign({}, pckg, {
                key: NewId('package'),
                completedMeditationsCount
            });
        });

        let className = "packages main ";
        className += this.props.className ? this.props.className : null;
        const {hideDescription} = this.props;
        return <div className={className}>
            {packages.map( (pckg) => <Package hideDescription={hideDescription} {...pckg} />)}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/PackageList.js